import { Injectable } from '@angular/core';
import { user as userData } from 'app/mock-api/common/user/data';

@Injectable({providedIn: 'root'})
export class AuthMockApi
{
    private readonly _secret: any;
    private _user: any = userData;

}
